import React, { useState, useEffect, startTransition } from 'react';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  useTheme
} from '@mui/material';
import { 
  Person as PersonIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import { Outlet, useNavigate } from 'react-router-dom';
import BottomNavBar from '../components/bda/BottomNavBar';
import { useAuth } from '../contexts/AuthContext';
import { notificationApi } from '../services/api';
import { useNotifications } from '../contexts/NotificationContext';

const MenuItemWithIcon = ({ icon, text, onClick }) => (
  <MenuItem onClick={onClick}>
    <ListItemIcon>
      {icon}
    </ListItemIcon>
    <ListItemText primary={text} />
  </MenuItem>
);

// This layout adds bottom navigation to all BDA pages
const BDALayout = ({ children, title = 'BDA Dashboard' }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { unreadCount } = useNotifications();
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);

  const handleProfileOpen = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };
  
  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  const navigateToProfile = () => {
    startTransition(() => {
      navigate('/bda/profile');
      handleProfileClose();
    });
  };
  
  const handleLogout = async () => {
    try {
      await logout();
      startTransition(() => {
        navigate('/bda/login', { replace: true });
      });
    } catch (error) {
      // Force logout even if API call fails
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      startTransition(() => {
        navigate('/bda/login', { replace: true });
      });
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh',}}>
      {/* Header */}
      <AppBar position="sticky" elevation={0} sx={{
       bgcolor: theme.palette.primary.light,
      }}>
        <Toolbar>
          <Typography variant="h5" sx={{ flexGrow: 1, fontWeight: 500, color: theme.palette.primary.main ,textTransform: 'uppercase',letterSpacing: '0.1rem',fontFamily:'Kanit'}}>
           Easy Health Digital Solutions
          </Typography>
          <IconButton color="inherit" onClick={handleProfileOpen}>
            <Avatar sx={{ bgcolor: theme.palette.primary.dark }}>
              {user?.name?.charAt(0) || 'B'}
            </Avatar>
          </IconButton>
        </Toolbar>
        
      </AppBar>

      {/* Profile Menu */}
      <Menu
        anchorEl={profileAnchorEl}
        open={Boolean(profileAnchorEl)}
        onClose={handleProfileClose}
        PaperProps={{
          elevation: 8,
          sx: {
            minWidth: 180,
            borderRadius: 2,
            mt: 1.5
          }
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {user?.name || 'BDA User'}
          </Typography>
        </Box>
        <Divider />
        <MenuItemWithIcon 
          icon={<PersonIcon fontSize="small" />} 
          text="My Profile" 
          onClick={navigateToProfile} 
        />
        <Divider />
        <MenuItemWithIcon 
          icon={<LogoutIcon fontSize="small" />} 
          text="Logout" 
          onClick={handleLogout} 
        />
      </Menu>

      {/* Main Content */}
      <Box sx={{ flex: 1, overflow: 'auto',  paddingBottom: '250px' }}>
        {children}
      </Box>
      
      {/* Bottom Navigation */}
      <BottomNavBar pendingNotifications={unreadCount} />
    </Box>
  );
};

export default BDALayout; 